// styles/base/foundations.ts
/**
 * Core theme foundations - palette, typography, spacing, and breakpoints
 */

import { applyCssVariables, brand, colors } from './tokens';

// tokens.ts is the source; :root follows it so index.scss's var(--…) agrees.
// Guarded so the theme can be imported in a node test environment.
if (typeof document !== 'undefined') applyCssVariables();

export const breakpoints = {
    values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
    },
};

export const palette = {
    mode: colors.isDark ? ('dark' as const) : ('light' as const),
    primary: {
        main: colors.primary,
        dark: colors.primaryDark,
        light: colors.primaryLight,
        contrastText: colors.onPrimary,
    },
    secondary: {
        main: colors.accent,
        contrastText: colors.accentContrastText,
    },
    error: {
        main: colors.error,
    },
    warning: {
        main: colors.warning,
        contrastText: colors.warningContrastText,
    },
    info: {
        main: colors.info,
        contrastText: brand.white,
    },
    success: {
        main: colors.success,
    },
    text: {
        primary: colors.text,
        secondary: colors.textSecondary,
    },
    divider: colors.border,
    background: {
        default: colors.ground,
        paper: colors.paper,
    },
    /** The strip under the app bar (DashboardHeader, Overview) */
    band: {
        main: colors.band,
        contrastText: colors.bandText,
    },
    appBar: {
        main: colors.appBar,
        contrastText: colors.appBarText,
    },
    dark: {
        main: colors.text,
        contrastText: colors.ground,
    },
    light: {
        main: colors.panelFill,
        contrastText: colors.text,
    },
    tint: {
        main: colors.primaryLight,
    },
    tintSecondary: {
        main: colors.surfaceSubtle,
    },
    highlight: {
        main: colors.accent,
    },
};

export const typography = {
    fontFamily: colors.fontStack,
    fontSize: 16,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 300 },
    button: {
        textTransform: 'none' as const,
        fontWeight: 400,
    },
    subtitle1: { fontSize: '0.85rem' },
    subtitle2: { fontSize: '0.8rem' },
    caption: { fontSize: '0.65rem' },
};

export const shape = {
    borderRadius: 4,
};

export const customExtensions = {
    chart: {
        borderColor: colors.border,
    },
};
